<template>
  <div>
    <div class="videoElement">
      <p>暂无视频</p>
      <p v-if="url === ''">暂无视频</p>
      <video
        v-else
        :ref="`video${gateId}`"
        muted
        autoplay
        class="videoItem"
      ></video>
    </div>
  </div>
</template>

<script>
// import { getRoleCode } from "@/utils/service";

export default {
  data() {
    return {
      flvPlayer: null,
      // url: 'http://stun.zoeeasy.com',
      videoElement: undefined,
      time: undefined,
      urlArr: [],
      index: 0,
      tryTimer: null,
      urlIndex: 0,
      urlTimer: null,
    };
  },
  props: {
    gateId: [Number, String],
    isPlay: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: undefined,
    },
  },
  watch: {
    gateId: function () {
      this.$nextTick(() => {
        this.init();
      });
    },
    url() {
      this.$nextTick(() => {
        this.init();
      });
    },
    $route: {
      handler: function(){
        this.$nextTick(() => {
          this.init();
        })
      },
      deep: true
    },
  },
  computed: {
    isCashier: function () {
      return this.$store.state.user.isCashier;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  beforeDestroy() {
    if (this.time) {
      clearTimeout(this.time);
    }
    if (this.tryTimer) {
      clearTimeout(this.tryTimer);
    }
    this.destroyPlayer();
  },
  methods: {
    init() {
      try {
        if (!this.gateId || !this.url) {
          return;
        }
        // 先销毁直播地址
        this.destroyPlayer().then(() => {
          if (window.flvjs.isSupported()) {
            let videoElement = (this.videoElement = this.$refs[
              `video${this.gateId}`
              ]);
            this.flvPlayer = window.flvjs.createPlayer({
              type: "flv",
              isLive: true,
              // url: `${this.url}:8003/live?port=1935&app=myapp&stream=movie${this.gateId}cam1`
              url: `${this.url}`,
              hasAudio: false
            });
            this.flvPlayer.attachMediaElement(videoElement);
            this.flvPlayer.load();
            this.flvPlayer.play();
            this.correctVideoTime();
            this.flvPlayer.on("error", (err) => {
              this.index++;
              // console.log("视频错误", err,'video$'+this.gateId,window.flvjs.ErrorTypes, this.index);
              if (err === window.flvjs.ErrorTypes.NETWORK_ERROR) {
                if (this.index >= 10) {
                  this.index = 0;
                  this.tryTimer = setTimeout(() => {
                    this.init();
                  }, 10000);
                } else {
                  clearInterval(this.tryTimer);
                  this.init();
                }
              }
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    destroyPlayer() {
      return new Promise((resolve) => {
        if (this.flvPlayer) {
          this.flvPlayer.pause();
          this.flvPlayer.unload();
          this.flvPlayer.detachMediaElement();
          this.flvPlayer.destroy();
          this.flvPlayer = null;
        }
        resolve();
      })
    },
    correctVideoTime() {
      if (this.time) {
        clearTimeout(this.time);
      }
      this.correctVideo();
      this.time = setTimeout(() => {
        this.correctVideoTime();
      }, 100000);
    },
    correctVideo() {
      // 矫正实时播放速度
      if (this.flvPlayer) {
        let buffered = this.flvPlayer.buffered;
        if (buffered.length > 0) {
          let end = buffered.end(0);
          if (end - this.flvPlayer.currentTime > 0.15) {
            this.flvPlayer.currentTime = end - 0.1;
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.videoElement {
  width: 100%;
  height: 205px;
  position: relative;
  line-height: 320px;
  font-size: 20px;
  font-weight: bold;
  p{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  & .videoItem {
    object-fit: fill;
    background: transparent;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 5;
  }
}
</style>
